import { on } from '@ember/modifier';
import { action, set } from '@ember/object';
import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import { eq, not, notEq, or } from 'ember-truth-helpers';
import GeneralCountryFlag from 'lumen/components/general/country-flag';
import GeneralEventName from 'lumen/components/general/event-name';
import GeneralTooltipsTooltipEvents from 'lumen/components/general/tooltips/tooltip-events';

interface GeneralDayDetailDayDetailEventsSignature {
  Args: {
    day: unknown;
  };
}

export default class GeneralDayDetailDayDetailEvents extends Component<GeneralDayDetailDayDetailEventsSignature> {
  isHovered = false;

  visibleFlags = 4;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get events() {
    if (
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      !this.args.day?.calendarEvents?.length &&
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      !this.args.day?.holidays?.length
    ) {
      // Returns undefined so we can check if there are any events or not.
      return undefined;
    }

    return {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      events: [...(this.args.day.calendarEvents ?? [])],
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      holidays: [...(this.args.day.holidays ?? [])],
    };
  }

  // Return the text to be displayed next to the event icon.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get singleEvent() {
    const { events } = this;
    let sumEvents = 0;
    let sumHolidays = 0;

    if (events && (events.events || events.holidays)) {
      if (
        events.events &&
        events.holidays.length === 0 &&
        events.events.length === 1
      ) {
        return {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          name: events.events[0].name,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isCancelled: events.events[0].isCancelled,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isUnconfirmed: events.events[0].isUnconfirmed,
          event: true,
        };
      }

      if (
        events.events &&
        events.events.length === 0 &&
        events.holidays &&
        events.holidays.length === 1
      ) {
        return {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          name: events.holidays[0].name,
          event: false,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          countries:
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            events.holidays[0].countries.length < this.visibleFlags
              ? // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                events.holidays[0].countries
              : ['multiple'],
          holiday: true,
        };
      }

      if (events.holidays) {
        sumHolidays += events.holidays.length;
      }
      if (events.events) {
        sumEvents += events.events.length;
      }
      if (sumEvents === 0) {
        // @ts-expect-error: Incorrect type
        let countries = [];
        events.holidays.forEach((holiday) => {
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          countries = countries.concat(holiday.countries);
        });
        countries =
          // @ts-expect-error: Incorrect type
          countries.length < this.visibleFlags ? countries : ['multiple'];
        return {
          name: `${sumHolidays} Holidays`,
          event: true,
          countries,
        };
      }
      if (sumHolidays === 0) {
        return {
          name: `${sumEvents} Events`,
          event: true,
        };
      }
      return {
        name:
          sumEvents +
          (sumEvents === 1 ? ' Event, ' : ' Events, ') +
          sumHolidays +
          (sumHolidays === 1 ? ' Holiday' : ' Holidays'),
        event: true,
      };
    }
    return this.args.day
      ? { name: 'No Events', event: true }
      : { name: '', event: true };
  }

  @action
  onMouseEnter(): void {
    set(this, 'isHovered', true);
  }

  @action
  onMouseLeave(): void {
    set(this, 'isHovered', false);
  }

  <template>
    {{#if this.events}}
      <div
        class="flex items-center justify-center gap-100"
        role="tooltip"
        {{on "mouseenter" this.onMouseEnter}}
        {{on "mouseleave" this.onMouseLeave}}
      >
        {{#if this.isHovered}}
          <EmberTooltip
            @isShown={{this.isHovered}}
            @side="left"
            @tooltipClass="base-tooltip day-detail-tooltip"
          >
            <GeneralTooltipsTooltipEvents
              @events={{this.events.events}}
              @holidays={{this.events.holidays}}
              @title="menu.events"
            />
          </EmberTooltip>
        {{/if}}
        {{#if
          (not (or this.singleEvent.holiday (eq this.events.events.length 0)))
        }}
          <PrismIcon @name="calendar-accepted" @size="small" />
        {{/if}}
        <GeneralEventName
          @event={{this.singleEvent}}
          @strikethrough={{this.singleEvent.isCancelled}}
          class="text-200--regular day-detail-events-placeholder"
        />
        {{#if (notEq this.events.holidays.length 0)}}
          <div class="flex items-center gap-100">
            {{#each this.singleEvent.countries as |country|}}
              <GeneralCountryFlag @countryCode={{country}} />
            {{/each}}
          </div>
        {{/if}}
      </div>
    {{/if}}
  </template>
}
